export const serviceScheduleKeys = {
    all: ['service-schedules'] as const,
    lists: () => [...serviceScheduleKeys.all, 'list'] as const,
    list: (projectId: string) => [...serviceScheduleKeys.lists(), projectId] as const,
    details: () => [...serviceScheduleKeys.all, 'detail'] as const,
    detail: (scheduleId: string) => [...serviceScheduleKeys.details(), scheduleId] as const,
}
